export class Constants {
  static BackgroundColor = '#eeeeee';
  static BorderColor = '#cccccc';
}
